/**
 * Text tokenization utilities shared across smart-capture's contradiction-check
 * keyword extraction. Pure — no MCP/kernel dependencies. Extracted from
 * tools/smart-capture.ts (STD-2 / DEC-1504 module-health ratchet); the call site
 * stays unchanged, only the implementation moved.
 */

// Stop words excluded from noun phrase / keyword extraction.
export const STOP_WORDS = new Set([
  "the", "and", "for", "are", "but", "not", "you", "all", "can", "has", "her",
  "was", "one", "our", "out", "day", "had", "hot", "how", "its", "may", "new",
  "now", "old", "see", "way", "who", "did", "get", "let", "say", "she", "too",
  "use", "from", "have", "been", "each", "that", "this", "with", "will", "they",
  "what", "when", "make", "like", "long", "look", "many", "some", "them", "than",
  "most", "only", "over", "such", "into", "also", "back", "just", "much", "must",
  "name", "very", "your", "after", "which", "their", "about", "would", "there",
  "should", "could", "other", "these", "first", "being", "those", "still", "where",
]);

export function tokenizeText(input: string): string[] {
  return input
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]+/gu, " ")
    .split(/\s+/)
    .filter(Boolean);
}
